module.exports = __webpack_public_path__ + "static/img/aboutus.23f1b5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus.png
// module id = 6uiW
// module chunks = 0